import React, { useEffect, useState } from "react";
import Button from "@shared/components/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEmail } from "@services/EmailContext";
import loginpageimg from "/loginpage_illustration.svg";
import logo from "/logo_new.svg";
import { useUserService } from "@utils/useUsers";
import { userService } from "@services/UserServices";
import { useTokenLoginRedirect } from "@pages/Home/utils/useTokenLoginRedirect";
import { performRedirect } from "@utils/redirect";
import { toastService } from "@services/ToastService";

const Login: React.FC = () => {
  const { setEmail } = useEmail();
  const [email, setEmailAddr] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { emailLogin } = useUserService();
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get("redirect");
  const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : null;

  useEffect(() => {
    const checkAuth = async () => {
      setLoading(true);
      const response = await userService.checkAuth();
      if (response && response.status === 200) {
        performRedirect("/assistant", redirectPath, navigate);
      }
      setLoading(false);
    };
    checkAuth();
  }, [navigate]);

  const submitLogin = async (event?: React.FormEvent) => {
    if (event) event.preventDefault();
    setError("");

    try {
      const response = await emailLogin(email.toLowerCase());
      if (response) {
        setEmail(email.toLowerCase());
        navigate("/check-email", {
          state: { timerStart: true, mailProvider: response.mail_provider },
        });
      } else {
        setError("User not found");
      }
    } catch (error: any) {
      if (error.response) {
        const message =
          error.response.data?.detail === "User is not active"
            ? "This account has been deactivated, Please contact your account administrator"
            : "E-mail is incorrect or user not found";

        toastService.error(message);
      } else {
        // Fallback for unexpected/network errors
        const message =
          error instanceof Error
            ? error.message
            : "An unexpected error occurred";

        toastService.error(message);
      }
    }
  };

  useTokenLoginRedirect();

  return (
    <>
      {!loading && (
        <div className="flex h-screen w-full">
          <div className="w-[60%] relative items-center justify-center hidden sm:flex">
            <img
              src={loginpageimg}
              alt="Workspace Illustration"
              className="absolute w-full h-full object-cover"
            />
            <div className="absolute top-6 left-6 p-4 ">
              <h2 className="text-lg 2xl:text-xl font-medium text-white">
                The Intuitive Workspace for
                <br />
                Philanthropic Organizations
              </h2>
            </div>
          </div>
          <div className="w-full sm:w-[40%] flex flex-col justify-center items-center px-6 sm:p-8 bg-white shadow-lg">
            <div className="max-w-[30rem] sm:w-[30rem] ">
              <div className="mb-[30px] flex justify-center items-center">
                <img src={logo} alt="The Ark Logo" className="w-35 h-35" />
              </div>
              <h1 className="w-full text-center text-xl 2xl:text-3xl font-bold text-gray-900 mb-6">
                Sign into your workspace
              </h1>
              <input
                id="email"
                type="email"
                autoComplete="email"
                placeholder="Email address"
                className="w-full px-4 py-3 mb-4 border text-sm 2xl:text-base border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                value={email}
                onChange={(e) => setEmailAddr(e.target.value)}
              />
              <Button onClick={submitLogin} label="Sign in" />
              <div className="mt-4 text-xs 2xl:text-sm text-center">
                Don't have an account?{" "}
                <button
                  onClick={() => navigate("/register")}
                  className="text-blue-600 font-medium"
                >
                  Register
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
